import React, { useState } from "react";
import PropTypes from "prop-types";
import Filter from "../offer/filter.jsx";
import StarRating from "../intern/starRating.jsx";
import { Link } from "react-router-dom";

const Offer = ({
  offers,
  listName,
  variant = "",
  className = "",
  link = "",
}) => {
  const [selected, setSelected] = useState("Plus récent");
  const [open, setOpen] = useState(false);
  const options = ["Plus récent", "Plus ancien"];

  const handleSelect = (value) => {
    setSelected(value);
    setOpen(false);
    if (value === "Plus ancien") {
      offers.sort((a, b) => a.id - b.id);
    } else {
      offers.sort((a, b) => b.id - a.id);
    }
  };

  // Classes BEM-like selon la variante
  const sectionClasses = `card-section${
    variant ? ` card-section--${variant}` : ""
  }${className ? ` ${className}` : ""}`;
  const containerClasses = `card-container${
    variant ? ` card-container--${variant}` : ""
  }`;
  const cardClasses = `cards${variant ? ` cards--${variant}` : ""}`;

  return (
    <section className={sectionClasses}>
      <Filter />
      {/* Offres */}
      <section
        className={containerClasses}
        aria-label="Liste des offres d'emploi"
      >
        <div className="card-header">
          <h2>
            {listName} ({offers.length})
          </h2>
          <div className="card-sort">
            <label>Trier par</label>
            <div className="custom-dropdown" onClick={() => setOpen(!open)}>
              <button className="custom-dropdown-button">
                {selected}
                <i
                  className={`fa-solid fa-chevron-down ${open ? "rotate" : ""}`}
                />
              </button>
              {open && (
                <ul className="custom-dropdown-menu">
                  {options.map((option) => (
                    <li
                      key={option}
                      onClick={() => handleSelect(option)}
                      className={`custom-dropdown-item ${
                        selected === option ? "active" : ""
                      }`}
                    >
                      {option}
                      {selected === option && (
                        <i className="fa-solid fa-check check-icon" />
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
        <ul className="cards-list">
          {offers.map((offer) => (
            <li key={offer.id} className="offer-item">
              <Link to={link} className={cardClasses}>
                <div className="card-gradient-bar" />
                <div className="card-content">
                  <div className="card-infos">
                    <img
                      src={require(`../../../src/assets/img/profilPicture/${
                        offer.img ? offer.img : "pdp.jpg"
                      }`)}
                      alt="profile picture"
                      style={{ width: "75px", height: "75px" }}
                      className="offer-image"
                    />
                    <article>
                      <h3>{offer.title}</h3>
                      <p>{offer.subtitle}</p>
                      <StarRating rating={offer.rating} />
                    </article>
                  </div>
                  <div className="card-tags">
                    <div className="card-work">
                      <i className="fa-solid fa-house" /> {offer.work}
                    </div>
                    <div className="card-location">
                      <i className="fa fa-map-marker-alt" /> {offer.location}
                    </div>
                  </div>
                  <div className="card-dates">
                    <span className="offer-title-time">{offer.titleTime}</span>
                    <span className="offer-time">{offer.time}</span>
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </section>
  );
};

Offer.propTypes = {
  offers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      location: PropTypes.string,
      time: PropTypes.string,
      rating: PropTypes.string,
      img: PropTypes.string,
    })
  ).isRequired,
  variant: PropTypes.string,
  className: PropTypes.string,
};

export default Offer;
